import React from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Input, InputNumber, Select, Radio, DatePicker, TimePicker, Checkbox, Slider, Upload, Button, Switch } from 'antd'
import dayjs from 'dayjs'
import { GoUpload } from "react-icons/go"

const customizeRequiredMark = (label, { required }) => {
  return (<>
    {label}
    {required && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
  </>)
}

const TextInput = ({ field_id, field_name, remark, required, no_margin, disabled }) => {  
  return (
    <Form.Item style={ no_margin ? { margin: 0, padding: 0 } : {}} label={field_name} name={field_id} extra={remark} rules={[ { required: (required && !disabled), message: `${field_name} is required` } ]}>
      <Input disabled={disabled} />
    </Form.Item>
  )
}

const PasswordInput = ({ field_id, field_name, remark, required, no_margin, disabled }) => {
  return (
    <Form.Item style={ no_margin ? { margin: 0, padding: 0 }  : {}} label={field_name} name={field_id} extra={remark} rules={[ { required: (required && !disabled), message: `${field_name} is required` } ]}>
      <Input.Password disabled={disabled} />
    </Form.Item>
  )
}

const TextArea = ({ field_id, field_name, remark, required, no_margin, disabled }) => {
  return (
    <Form.Item style={ no_margin ? { margin: 0, padding: 0 }  : {}} label={field_name} name={field_id} extra={remark} rules={[ { required: (required && !disabled), message: `${field_name} is required` } ]}>
      <Input.TextArea disabled={disabled}   />
    </Form.Item>
  )
} 

const NumberInput = ({ field_id, field_name, remark, required, no_margin, disabled, props }) => {
  return (
    <Form.Item style={ no_margin ? { margin: 0, padding: 0 }  : {}} label={field_name} name={field_id} extra={remark} rules={[ { required: (required && !disabled), message: `${field_name} is required` } ]}>
      <InputNumber style={{ width: "100%" }}  disabled={disabled} min={props["min"]} max={props["max"]} step={props["step"]} precision={props["precision"]}/>
    </Form.Item>
  )
}

const Dropdown = ({ field_id, field_name, remark, required, no_margin, disabled, props }) => {
  return (
    <Form.Item style={ no_margin ? { margin: 0, padding: 0 }  : {}} label={field_name} name={field_id} extra={remark} rules={[ { required: (required && !disabled), message: `${field_name} is required` } ]}>
      <Select mode={props["multiple"] ? "multiple" : ""} options={props["options"]} disabled={disabled} dropdownStyle={{ zIndex: 1500 }}/>
    </Form.Item>
  )
} 

const CheckList = ({ field_id, field_name, remark, required, no_margin, disabled, props }) => {
  return (
    <Form.Item style={ no_margin ? { margin: 0, padding: 0 } : {}} label={field_name} name={field_id} extra={remark} rules={[ { required: (required && !disabled), message: `${field_name} is required` } ]}>
      {props["multiple"] ? (
        <Checkbox.Group style={{ width: "100%" }} options={props["options"]} disabled={disabled} />
      ) : (
        <Radio.Group style={{ width: "100%" }} options={props["options"]} disabled={disabled} />
      )}
    </Form.Item>
  )
} 

const Checkbox_ = ({ field_id, field_name, remark, required, no_margin, disabled }) => {
  return (
    <Form.Item style={ no_margin ? { margin: 0, padding: 0 }  : {}} name={field_id} extra={remark} rules={[ { required: (required && !disabled), message: `${field_name} is required` } ]} valuePropName="checked">
      <Checkbox disabled={disabled}>{field_name}</Checkbox>
    </Form.Item>
  )
}

const DatePicker_ = ({ field_id, field_name, remark, required, no_margin, disabled, props }) => {
  const { RangePicker } = DatePicker
  
  return (
    <Form.Item style={ no_margin ? { margin: 0, padding: 0 }  : {}} label={field_name} name={field_id} extra={remark} rules={[ { required: (required && !disabled), message: `${field_name} is required` } ]}>
      {props["range"] ? (
        <RangePicker
          style={{ width: "100%" }} popupStyle={{ zIndex: 1500 }} disabled={disabled} showToday={false}
          minDate={props["min"] ? dayjs(props["min"]) : null}
          maxDate={props["max"] ? dayjs(props["max"]) : null}
        />
      ) : (
        <DatePicker
          style={{ width: "100%" }} popupStyle={{ zIndex: 1500 }} disabled={disabled} showToday={false}
          minDate={props["min"] ? dayjs(props["min"]) : null}
          maxDate={props["max"] ? dayjs(props["max"]) : null}
        />
      )}
    </Form.Item>
  )
}

const TimePicker_ = ({ field_id, field_name, remark, required, no_margin, disabled, props }) => {
  const { RangePicker } = TimePicker

  function range(start, end) {
    return Array(end - start + 1).fill().map((_, idx) => start + idx)
  }

  const maxHourT = dayjs(props["max"]).hour()
  const minHourT = dayjs(props["min"]).hour()
  const maxMinuteT = dayjs(props["max"]).minute()
  const minMinuteT = dayjs(props["min"]).minute()

  const disabledTime = () => ({
    disabledHours: () => {
      const start = props["min"] ? range(0, minHourT-1) : []
      const end = props["max"] ? range(maxHourT+1, 23) : []
      return [...start, ...end]
    },
    disabledMinutes: (selectedHour) => {
      if (props["min"] && props["max"] && selectedHour === maxHourT && selectedHour === maxHourT) {
        return [...range(0, minMinuteT-1), ...range(maxMinuteT+1, 60)]
      }
      else if (props["min"] && selectedHour === minHourT) {
        return range(0, minMinuteT-1)
      }
      else if (props["max"] && selectedHour === maxHourT) {
        return range(maxMinuteT+1, 60)
      }
      else {
        return []
      }
    }
  })
  
  return (
    <Form.Item style={ no_margin ? { margin: 0, padding: 0 }  : {}} label={field_name} name={field_id} extra={remark} rules={[ { required: (required && !disabled), message: `${field_name} is required` } ]}>
      {props["range"] ? (
        <RangePicker
          style={{ width: "100%" }} popupStyle={{ zIndex: 1500 }} disabled={disabled} format='HH:mm' showToday={false}
          disabledTime={disabledTime}
        />
      ) : (
        <TimePicker
          style={{ width: "100%" }} popupStyle={{ zIndex: 1500 }} disabled={disabled} format='HH:mm' showToday={false}
          disabledTime={disabledTime}
        />
      )}
    </Form.Item>
  )
}

const DatetimePicker = ({ field_id, field_name, remark, required, no_margin, disabled, props }) => {
  function range(start, end) {
    return Array(end - start + 1).fill().map((_, idx) => start + idx)
  }

  const maxDateDT = dayjs(props["max"])
  const minDateDT = dayjs(props["min"])
  const maxHourDT = dayjs(props["max"]).hour()
  const minHourDT = dayjs(props["min"]).hour()
  const maxMinuteDT = dayjs(props["max"]).minute()
  const minMinuteDT = dayjs(props["min"]).minute()

  const disabledDateTime = (date) => ({
    disabledHours: () => {
      if (props["min"] && props["max"] && date.isSame(minDateDT, "day") && date.isSame(maxDateDT, "day")) {
        return [...range(0, minHourDT-1), ...range(maxHourDT+1, 60)]
      }
      else if (props["min"] && date.isSame(minDateDT, "day")) {
        return range(0, minHourDT-1)
      }
      else if (props["max"] && date.isSame(maxDateDT, "day")) {
        return range(maxHourDT+1, 23)
      }
      else {
        return []
      }
    },
    disabledMinutes: (selectedHour) => {
      if (props["min"] && props["max"] && date.isSame(minDateDT, "day") && date.isSame(maxDateDT, "day") && selectedHour === maxHourDT && selectedHour === minMinuteDT) {
        return [...range(0, minMinuteDT-1), ...range(maxMinuteDT+1, 60)]
      }
      else if (props["min"] && date.isSame(minDateDT, "day") && selectedHour === minHourDT) {
        return range(0, minMinuteDT-1)
      }
      else if (props["max"] && date.isSame(maxDateDT, "day") && selectedHour === maxHourDT) {
        return range(maxMinuteDT+1, 60)
      }
      else {
        return []
      }
    }
  })

  return (
    <Form.Item style={ no_margin ? { margin: 0, padding: 0 }  : {}} label={field_name} name={field_id} extra={remark} rules={[ { required: (required && !disabled), message: `${field_name} is required` } ]}>
      <DatePicker
        showTime style={{ width: "100%" }} disabled={disabled} format='YYYY-MM-DD HH:mm' showToday={false}
        minDate={props["min"] ? dayjs(props["min"]) : null}
        maxDate={props["max"] ? dayjs(props["max"]) : null}
        disabledTime={disabledDateTime}
      />  
    </Form.Item>
  )
}

const SliderField = ({ field_id, field_name, remark, required, no_margin, disabled, props }) => {
  return (
    <Form.Item style={ no_margin ? { margin: 0, padding: 0 }  : {}} name={field_id} extra={remark} label={field_name} rules={[ { required: required, message: `${field_name} is required` } ]}>
      <Slider disabled={disabled} min={props["min"]} max={props["max"]} step={props["step"]}/>
    </Form.Item>
  )
}

const NumberInputWithSlider = ({ field_id, field_name, remark, required, no_margin, disabled, props }) => {
  return (
    <div style={{ display: "flex", flexDirection:"row" }}>
      <div style={{ width: "80%" }}>
        <SliderField field_id={field_id} field_name={field_name} required={required} no_margin={no_margin} disabled={disabled} props={props} /> 
      </div>

      <div style={{ width: "20%", paddingLeft: "10px" }}>
        <NumberInput field_id={field_id} field_name=" " disabled={disabled} no_margin={no_margin} props={props}/>
      </div>
    </div>
  )
}

const ToggleSwitch = ({ field_id, field_name, remark, required, no_margin, disabled }) => {
  return (
    <Form.Item style={ no_margin ? { margin: 0, padding: 0 }  : {}} name={field_id} extra={remark} label={field_name}>
      <Switch required={required} disabled={disabled}/>
    </Form.Item>
  )
}

const AttachmentField = ({ field_id, field_name, remark, required, no_margin, disabled, props }) => {
  return (
    <Form.Item style={ no_margin ? { margin: 0, padding: 0 }  : {}} name={field_id} extra={remark} label={field_name} rules={[ { required: required, message: `${field_name} is required` } ]}>    
      <Upload multiple={props["multiple"]} maxCount={props["maxCount"]} beforeUpload={() => false} accept={props["accept"]}>
        <Button icon={<GoUpload />} disabled={disabled}>Upload</Button>
      </Upload>
    </Form.Item>
  )
}

const FormContainer = ({ form, onFinish, initialValues, children }) => {
  const { t } = useTranslation()

  return (
    <Form form={form} layout="vertical" requiredMark={customizeRequiredMark} onFinish={onFinish} initialValues={initialValues} style={{ width: "100%", padding: "10px" }}>
      {children}

      <Button block type="primary" htmlType="submit">
        {t("general_submit")}
      </Button>
    </Form>
  )
}

export { TextInput, PasswordInput, TextArea, NumberInput, CheckList, Checkbox_ as Checkbox, Dropdown, DatePicker_ as DatePicker, TimePicker_ as TimePicker, DatetimePicker, SliderField, AttachmentField, ToggleSwitch, NumberInputWithSlider, FormContainer }
